import { SWRConfiguration } from 'swr';

import { FullEmploymentData } from '~/data/employment/types';
import { useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const getFullEmploymentData = (
  employeeId: number | string,
  employmentId?: number | string,
): Promise<FullEmploymentData> => {
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId || 'current'}/full`,
  ).then((r) => r.json());
};

type PropsType = {
  employeeId: number;
  employmentId?: number | string;
};
export const useGetFullEmploymentData = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { employeeId, employmentId } = props;

  const { data, isLoading, error } = useSWR<FullEmploymentData>(
    !!employeeId && !isDisabled
      ? ['fullEmploymentData', employeeId, employmentId]
      : null,
    () => getFullEmploymentData(employeeId, employmentId),
    swrConfig,
  );

  return {
    data,
    isLoading,
    error,
  };
};
